// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IvujOkEYtCF0xo {
  padding: var(--ds-space-150, 10px);
}
.IvujOkEYtCF0xo .pzykttGljW7t0u {
  font-weight: var(--ds-font-weight-regular, 400);
}
.IvujOkEYtCF0xo .dOa7qc0sVLWguu {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-300, 25px);
}
.IvujOkEYtCF0xo .UDvfeaHhET2g7K {
  font-weight: var(--ds-font-weight-regular, 400);
  display: flex;
  align-items: center;
  min-height: 64px;
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.IvujOkEYtCF0xo .sQSQfbirNeqxaP {
  font-weight: var(--ds-font-weight-regular, 400);
  display: flex;
  align-items: center;
  margin-bottom: var(--ds-space-0, 0px);
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  text-align: center;
}
.IvujOkEYtCF0xo .sQSQfbirNeqxaP strong {
  width: 100%;
}
.IvujOkEYtCF0xo .RT6qz9GwGe81zP {
  font-weight: var(--ds-font-weight-regular, 400);
  display: flex;
  align-items: center;
  min-height: 48px;
  font-size: 12px;
  line-height: 16px;
}
.IvujOkEYtCF0xo .kzRtw7uXez7wA6 {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
  overflow-wrap: break-word;
  font-size: 26px;
}
.IvujOkEYtCF0xo .LQ_RBaRJLYtCnf,
.IvujOkEYtCF0xo .cAxSj7gg1nn_wt,
.IvujOkEYtCF0xo .Ss0kBNo4hQ3u8l {
  font-weight: var(--ds-font-weight-regular, 400);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.IvujOkEYtCF0xo .jEvl90PeAA0YnO {
  margin-top: var(--ds-space-200, 16px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.IvujOkEYtCF0xo .cAxSj7gg1nn_wt {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin: var(--ds-space-400, 32px) var(--ds-space-300, 25px) var(--ds-space-300, 25px) 30px;
}
.IvujOkEYtCF0xo:nth-last-child(2) {
  border-top: 3px solid var(--ds-border-discovery, #8270db);
  border-right: 4px solid var(--ds-border-discovery, #8270db);
  border-left: 3px solid var(--ds-border-discovery, #8270db);
}
.IvujOkEYtCF0xo:nth-last-child(2) .dOa7qc0sVLWguu {
  margin-top: var(--ds-space-050, 3px);
}
.IvujOkEYtCF0xo:nth-last-child(2)::before {
  margin-top: var(--ds-space-250, 20px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  content: attr(data-value);
  position: relative;
  top: var(--ds-space-negative-200, -15px);
  width: 85px;
  height: 24px;
  padding: var(--ds-space-075, 5px);
  border-radius: var(--ds-radius-xsmall, 2px);
  background-color: var(--ds-border-discovery, #8270db);
  color: var(--ds-text-inverse, #ffffff);
  line-height: inherit;
}
`, ""]);
// Exports
export var planCell = `IvujOkEYtCF0xo`;
export var purchase = `pzykttGljW7t0u`;
export var name = `dOa7qc0sVLWguu`;
export var info = `UDvfeaHhET2g7K`;
export var infoHeading = `sQSQfbirNeqxaP`;
export var infoBody = `RT6qz9GwGe81zP`;
export var price = `kzRtw7uXez7wA6`;
export var frequency = `LQ_RBaRJLYtCnf`;
export var pricingVaries = `cAxSj7gg1nn_wt`;
export var currentPlan = `Ss0kBNo4hQ3u8l`;
export var pricingVariesRefreshed = `jEvl90PeAA0YnO`;
export default ___CSS_LOADER_EXPORT___;
